import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
// import FormImageUpload from "../../components/formFields/FormImageUpload";
import {
  createGalleryType,
  getAllGalleryType,
  getGalleryTypeByID,
  updateGalleryType,
} from "./services/gallerytype.services";
import { clearGalleryTypeDetails } from "./gallerytypeSlice";
// import FormRichTextField from "../../components/formFields/FormRichTextField";

import { RxCross1 } from "react-icons/rx";
import { closed } from "../../components/drawer/drawerSlice";
import IconButton from "../../components/common/IconButton";
// import { getFile } from "../../_helper/helper";

const CreateGalleryType: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const GalleryTypeID = location.state?.GalleryTypeID;
  const GalleryTypeID = useAppSelector((state) => state.drawer.data);
  const GalleryTypeDetail = useAppSelector(
    (state) => state.gallerytype.GalleryTypeDetail,
  );
  const loading = useAppSelector((state) => state.gallerytype.formLoading);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [GalleryTypeDetail]);

  useEffect(() => {
    if (GalleryTypeID) {
      dispatch(getGalleryTypeByID(GalleryTypeID));
    }
    return () => {
      dispatch(clearGalleryTypeDetails());
    };
  }, [GalleryTypeID]);

  const handleSubmit = async (values: any) => {
    const formData = {
      GalleryType: values.GalleryType ?? "",
      IsActive: values.IsActive === 1,
    };

    try {
      if (GalleryTypeID) {
        const editPayload = {
          ...formData,
          ID: GalleryTypeID,
        };

        const response = await dispatch(updateGalleryType(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          dispatch(getAllGalleryType());
          dispatch(clearGalleryTypeDetails());
        }
      } else {
        const response = await dispatch(createGalleryType(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          dispatch(getAllGalleryType());
          dispatch(clearGalleryTypeDetails());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div>
        <Form
          onSubmit={handleSubmit}
          key={formKey}
          initialValues={GalleryTypeDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
                <GridLayoutItem className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {GalleryTypeID ? "Update GalleryType" : "Add GalleryType"}
                  </Typography.h4>

                  <IconButton
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                    icon={RxCross1}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="GalleryType"
                    label="GalleryType"
                    placeholder="GalleryType"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    placeholder="i.e. Active"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={GalleryTypeID ? "Update" : "Save"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateGalleryType;
